import { createContext, useContext } from 'react';

export type RecaptchaContext = {
  recaptchaV3Key: string;
  recaptchaEnabled: boolean;
};

export const RecaptchaKeyContext = createContext<RecaptchaContext>({
  recaptchaV3Key: '',
  recaptchaEnabled: false,
});

export const useRecaptcha = () =>
  useContext<RecaptchaContext>(RecaptchaKeyContext);
